import { SegmentedControl } from '@m/alchemy-ui/SegmentedControl';
import { useIntl } from 'react-intl';
import { type DateGranularity } from '../helpers';

interface GranularitySelectorProps {
  granularity: DateGranularity;
  onChange: (granularity: DateGranularity) => void;
}

export const GranularitySelector = ({ granularity, onChange }: GranularitySelectorProps) => {
  const intl = useIntl();

  const controls = [
    {
      label: intl.formatMessage({ id: 'day', defaultMessage: 'Day' }),
      value: 'day' as DateGranularity
    },
    {
      label: intl.formatMessage({ id: 'week', defaultMessage: 'Week' }),
      value: 'week' as DateGranularity
    },
    {
      label: intl.formatMessage({ id: 'month', defaultMessage: 'Month' }),
      value: 'month' as DateGranularity
    },
    {
      label: intl.formatMessage({ id: 'year', defaultMessage: 'Year' }),
      value: 'year' as DateGranularity
    }
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <span id="groupby-label">{intl.formatMessage({ id: 'groupBy', defaultMessage: 'Group by' })}</span>
      <SegmentedControl
        role="radiogroup"
        aria-labelledby="groupby-label"
        activeControlValue={granularity}
        onControlChange={({ value }) => onChange(value as DateGranularity)}
        controls={controls}
      />
    </div>
  );
};
